import { AbstractScene } from './AbstractScene';
import { AssetsPreloader } from '../utils/AssetPreloader';
import { AudioManager } from '../core/AudioManager';
export class BootScene extends AbstractScene {
    constructor() {
        super('boot');
        this.hasAssetsLoaded = false;
        this.hasPlayerLoggedIn = true;
        this.assetsPreloader = new AssetsPreloader(this);
    }
    preload() {
        // Load all loading bar related assets here assets here
        this.assetsPreloader.loadBootSceneAssets();
        // @ts-ignore User Activation Exists on some browsers
        if (navigator.userActivation && navigator.userActivation.hasBeenActive) {
            // this.game.scale.startFullscreen();
        }
    }
    resizeAndRepositionElements() {
        //
    }
    create() {
        this.audioManager = new AudioManager(this);
        this.audioManager.initBootAudio();
        this.handleLoadingProgress();
        this.assetsLoadedHandler();
        // To load main game assets
        this.assetsPreloader.loadGameSceneAssets();
        // const token = GetParams('token');
        // if (token && token !== '') {
        // 	console.warn('token', token);
        // 	this.handlePlayerLogin(token as string);
        // }
        // @ts-ignore Called from within react native
        const reactNativeWebView = window.ReactNativeWebView;
    }
    handlePlayerLogin(token) { }
    handleLoadingProgress() {
        this.load.on('progress', (percentage) => {
            this.updateLoadingBar(percentage);
        });
    }
    updateLoadingBar(percentage) {
        console.warn('percentage', percentage);
    }
    assetsLoadedHandler() {
        this.load.on('complete', () => {
            this.hasAssetsLoaded = true;
            this.handleSceneExit();
        });
    }
    handleSceneExit() {
        if (this.hasAssetsLoaded && this.hasPlayerLoggedIn) {
            this.turnOffResizeHandler();
            this.assetsPreloader.createAnimations();
            this.scene.start('game');
        }
    }
}
